import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';

import supabase from '../../../../supabaseClient';
import { useAuth } from '../../../../contexts/authContext';

const StudentLMSLayout = () => {
  const [newFeedback, setNewFeedback] = useState(0);
  const [newForumPosts, setNewForumPosts] = useState(0);

  const { user } = useAuth();

  useEffect(() => {
    const userId = user?.id;
    if (userId) {
      supabase.rpc('count_new_feedback', { student_id: userId })
        .then(({ data }) => setNewFeedback(data || 0));
      supabase.rpc('count_new_forum_posts', { user_id: userId })
        .then(({ data }) => setNewForumPosts(data || 0));
    }
  }, [user]);

  return (
    <div className="lms-layout">
      <main className="lms-main-content" tabIndex={-1}>
        <Outlet />
      </main>
    </div>
  );
};

export default StudentLMSLayout;
